export default __webpack_public_path__ + "static/media/Searock.21e16c09.webp";